import { json } from "@sveltejs/kit";
import { t as toPostmarkConfig, g as getReviewRequestConfig, p as postmarkClient } from "../../../../../../chunks/mailer.js";
import { s as stripe } from "../../../../../../chunks/stripe.js";
import uniqBy from "lodash/uniqBy.js";
const getAllCustomers = async (customers = [], startingAfter) => {
  const response = await stripe.customers.list({
    starting_after: startingAfter,
    limit: 100
  });
  if (response.has_more) {
    return getAllCustomers(
      [...customers, ...response.data],
      response.data.at(response.data.length - 1)?.id
    );
  }
  return [...customers, ...response.data];
};
const GET = async () => {
  const customers = await getAllCustomers();
  const uniqueCustomers = uniqBy(customers, "email");
  const messages = uniqueCustomers.map((customer) => ({
    ...toPostmarkConfig(
      getReviewRequestConfig(customer.email, customer.name)
    ),
    MessageStream: "broadcast"
  }));
  await postmarkClient.sendEmailBatch(messages);
  return json({
    success: true
  });
};
export {
  GET
};
